export default __webpack_public_path__ + "static/media/login.9b921dbc.png";